const o="2.39.0";export{o as version};
